import { defineComponent as _defineComponent } from 'vue'
import RewardsBadgeWithColor from 'Src/js/components/RewardsBadgeWithColor.vue';
import { computed, nextTick, onBeforeUnmount, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'JoinRewardsCallout',
  props: {
    points: { default: "000.00" },
    skipCartMerge: { type: Boolean, default: false },
    hasItemsToShip: { type: Boolean, default: false },
    currentShippingOffer: { default: '' },
    customerHasRewards: { type: Boolean, default: false },
    inSideMenu: { type: Boolean, default: false }
  },
  emits: ["join-rewards-click"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'join-rewards-click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { points: string, skipCartMerge: boolean, hasItemsToShip: boolean, currentShippingOffer: string, customerHasRewards: boolean, inSideMenu: boolean }





const joinRewardsCalloutBtn = ref<HTMLElement | null>();
const isButtonWide = ref(false);

const showShippingOffer = computed(() => {
	return props.hasItemsToShip && !!props.currentShippingOffer;
});


let resizeObserver: ResizeObserver;
onMounted(async () => {
	await nextTick();
	resizeObserver = new ResizeObserver((entries) => {
		handleResizeUpdate();
	});

	resizeObserver.observe(joinRewardsCalloutBtn.value);
	handleResizeUpdate();
});

onBeforeUnmount(() => {
	resizeObserver?.disconnect();
});

function handleResizeUpdate() {
	if (!joinRewardsCalloutBtn.value) return;

	const width = joinRewardsCalloutBtn.value.getBoundingClientRect()?.width;

	if (width > 500) {
		isButtonWide.value = true;
	} else {
		isButtonWide.value = false;
	}

}

function joinRewards() {
	if (props.inSideMenu) {
		emit('join-rewards-click');
	} else {
		Blain.Rewards.showJoinRewardsSidePanel('join', props.skipCartMerge);
	}
}

return { __sfc: true,props, emit, joinRewardsCalloutBtn, isButtonWide, showShippingOffer, resizeObserver, handleResizeUpdate, joinRewards, RewardsBadgeWithColor }
}

})